import { defineStore } from 'pinia'
export const useMainStore = defineStore('main', {
  state: () => ({
    locales: ['en', 'zh-hant', 'es'],
    locale: 'en',
    isMobile: false
  }),
  actions: {}
})
